import { Link, useLocation } from 'react-router-dom';
import { flushScrollToTop } from '../utils/scrollLock';

const normalizePath = (path) => {
  if (!path) return '/';
  const base = path.split('?')[0].split('#')[0];
  if (base === '/') return '/';
  return base.replace(/\/$/, '');
};

export const isSameRoute = (currentPath, targetPath) =>
  normalizePath(currentPath) === normalizePath(targetPath);

export const useSmartNavClick = (to, onNavigate) => {
  const location = useLocation();

  return (event) => {
    if (isSameRoute(location.pathname, to)) {
      event.preventDefault();
    }
    onNavigate?.(event);
    flushScrollToTop();
  };
};

const SmartLink = ({ to, onClick, children, className, ...rest }) => {
  const handleClick = useSmartNavClick(to, onClick);

  return (
    <Link to={to} onClick={handleClick} className={className} {...rest}>
      {children}
    </Link>
  );
};

export default SmartLink;
